export function initHeader() {
const header = document.querySelector('#header');
if (!header) return;

// Cache DOM elements
const menuButton = header.querySelector('.menu-button');
const headerBorder = header.querySelector('#headerBorder');
const megamenuItems = header.querySelectorAll('.has-megamenu');
const megamenus = header.querySelectorAll('.megamenu');
const grandchildToggles = header.querySelectorAll('.grandchild-toggle');
    
// Mobile menu elements
const mobileMenu = document.getElementById('mobile-menu');
const mobileMenuClose = document.getElementById('mobileClose');
const mobileMenuOverlay = document.querySelector('.mobile-menu-overlay');
const mobileSubmenuToggles = document.querySelectorAll('.mobile-submenu-toggle');
const mobileGrandchildToggles = document.querySelectorAll('.mobile-grandchild-toggle');
const mobileBackButtons = document.querySelectorAll('.mobile-back-button');
const mobilePanels = document.querySelectorAll('.mobile-menu-panel');
    
let panelHistory = ['main']; // Track panel navigation history
    
const scrollThreshold = 50;
let isScrolled = false;
let isMegamenuOpen = false;
let isMobileMenuOpen = false;
let isRestoringState = false;
let ticking = false;
let currentOpenMegamenu = null;
let lastScrollY = window.scrollY;
let isInitialLoad = true;
let lastScrollDirection = null; // Track last scroll direction: 'up' or 'down'

// ============================================
// CONFIGURATION
// ============================================
const RESIZE_DEBOUNCE_DELAY = 250;
const MEGAMENU_CONFIG = {
    cookieName: 'openMegamenuId',
    persistAcrossReloads: true
};
    
// Get initial theme from header element
const initialTheme = header.getAttribute('data-initial-theme') || 'theme-white';
    
let megamenuCloseTimer = null;
let currentTheme = initialTheme;
let currentScrolledState = false;
    
// ============================================
// COOKIE HELPERS
// ============================================
function setCookie(name, value, days = 1) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
}
    
function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
}
    
function deleteCookie(name) {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
}

// ============================================
// THEME & STATE MANAGEMENT (Class-based!)
// ============================================
function applyTheme(theme) {
    if (theme === currentTheme) return;
    // Remove all theme classes
    header.classList.remove('theme-white', 'theme-transparent', 'theme-dark');
    // Add the specified theme
    header.classList.add(theme);
    currentTheme = theme;
}

function applyScrolledState(scrolled) {
    if (scrolled === currentScrolledState) return;
    currentScrolledState = scrolled;
    if (scrolled) {
        header.classList.add('header--scrolled');
    } else {
        header.classList.remove('header--scrolled');
    }
}


    // ============================================
    // GRANDCHILD MENU TOGGLES
    // ============================================
    grandchildToggles.forEach(toggle => {
        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            const menu = toggle.nextElementSibling;
            if (!menu || !menu.classList.contains('grandchild-menu')) return;
            
            const isOpen = toggle.getAttribute('aria-expanded') === 'true';
            
            // Close all other grandchild menus
            grandchildToggles.forEach(otherToggle => {
                if (otherToggle !== toggle) {
                    const otherMenu = otherToggle.nextElementSibling;
                    if (otherMenu && otherMenu.classList.contains('grandchild-menu')) {
                        otherMenu.classList.remove('opacity-100', 'visible', 'scale-y-100');
                        otherMenu.classList.add('opacity-0', 'invisible', 'scale-y-0');
                        otherToggle.setAttribute('aria-expanded', 'false');
                        otherToggle.style.transform = 'rotate(0deg)';
                    }
                }
            });
            
            if (isOpen) {
                menu.classList.remove('opacity-100', 'visible', 'scale-y-100');
                menu.classList.add('opacity-0', 'invisible', 'scale-y-0');
                toggle.setAttribute('aria-expanded', 'false');
                toggle.style.transform = 'rotate(0deg)';
            } else {
                menu.classList.remove('opacity-0', 'invisible', 'scale-y-0');
                menu.classList.add('opacity-100', 'visible', 'scale-y-100');
                toggle.setAttribute('aria-expanded', 'true');
                toggle.style.transform = 'rotate(45deg)';
            }
        });
    });

    // ============================================
    // MEGAMENU CONTROL FUNCTIONS
    // ============================================
    function getMegamenuId(megamenu) {
        const parentItem = megamenu.closest('.has-megamenu');
        if (!parentItem) return null;
        
        const link = parentItem.querySelector('a');
        if (!link) return null;
        
        return link.getAttribute('href') || link.textContent.trim();
    }
    
    function saveMegamenuState(megamenuId) {
        if (MEGAMENU_CONFIG.persistAcrossReloads && megamenuId) {
            setCookie(MEGAMENU_CONFIG.cookieName, megamenuId);
        }
    }
    
    function clearMegamenuState() {
        if (MEGAMENU_CONFIG.persistAcrossReloads) {
            deleteCookie(MEGAMENU_CONFIG.cookieName);
        }
    }
    
    function getSavedMegamenuId() {
        if (MEGAMENU_CONFIG.persistAcrossReloads) {
            return getCookie(MEGAMENU_CONFIG.cookieName);
        }
        return null;
    }
    
    function openMegamenu(megamenu) {
        if (!megamenu) return;
        
        // Close any other open megamenus
        megamenus.forEach(menu => {
            if (menu !== megamenu) {
                closeMegamenu(menu);
            }
        });
        
        currentOpenMegamenu = megamenu;
        
        megamenu.classList.add('megamenu-open');
        isMegamenuOpen = true;
        
        // Set aria-expanded on the trigger link
        const triggerLink = megamenu.closest('.has-megamenu')?.querySelector('a');
        if (triggerLink) {
            triggerLink.setAttribute('aria-expanded', 'true');
        }
        
        // Remove scrolled state to expand header back to normal size
        applyScrolledState(false);
        
        // Switch to white theme when megamenu opens
        applyTheme('theme-white');
        
        // Hide header border when megamenu opens
        if (headerBorder) {
            headerBorder.classList.add('border-hidden');
        }
        
        const megamenuId = getMegamenuId(megamenu);
        if (!isRestoringState) {
            saveMegamenuState(megamenuId);
        }
    }
    
    function closeMegamenu(megamenu) {
        if (!megamenu) return;
        
        megamenu.classList.remove('megamenu-open');
        
        // Set aria-expanded on the trigger link
        const triggerLink = megamenu.closest('.has-megamenu')?.querySelector('a');
        if (triggerLink) {
            triggerLink.setAttribute('aria-expanded', 'false');
        }
        
        // Close all grandchild menus when megamenu closes
        const toggles = megamenu.querySelectorAll('.grandchild-toggle');
        toggles.forEach(toggle => {
            const menu = toggle.nextElementSibling;
            if (menu && menu.classList.contains('grandchild-menu')) {
                menu.classList.remove('opacity-100', 'visible', 'scale-y-100');
                menu.classList.add('opacity-0', 'invisible', 'scale-y-0');
                toggle.setAttribute('aria-expanded', 'false');
                toggle.style.transform = 'rotate(0deg)';
            }
        });
        
        if (currentOpenMegamenu === megamenu) {
            currentOpenMegamenu = null;
            isMegamenuOpen = false;
            
            // Show header border when all megamenus are closed
            if (headerBorder) {
                headerBorder.classList.remove('border-hidden');
            }
            
            clearMegamenuState();
            
            // Clear any existing timer
            if (megamenuCloseTimer) {
                clearTimeout(megamenuCloseTimer);
            }
            
            // Revert theme based on scroll state
            if (!isInitialLoad) {
                megamenuCloseTimer = setTimeout(() => {
                    updateHeaderOnScroll(true);
                }, 0);
            }
        }
    }
    
    function closeAllMegamenus() {
        megamenus.forEach(closeMegamenu);
        currentOpenMegamenu = null;
        isMegamenuOpen = false;
        
        if (headerBorder) {
            headerBorder.classList.remove('border-hidden');
        }
        
        clearMegamenuState();
        
        if (megamenuCloseTimer) {
            clearTimeout(megamenuCloseTimer);
        }
        
        if (!isInitialLoad) {
            megamenuCloseTimer = setTimeout(() => {
                updateHeaderOnScroll(true);
            }, 0);
        }
    }
    
    function toggleMegamenu(megamenu) {
        if (!megamenu) return;
        
        const isOpen = megamenu.classList.contains('megamenu-open');
        
        if (isOpen) {
            closeMegamenu(megamenu);
        } else {
            openMegamenu(megamenu);
        }
    }
    
    function restoreMegamenuState() {
        const alreadyOpen = Array.from(megamenus).find(m => m.classList.contains('megamenu-open'));
        
        if (alreadyOpen) {
            currentOpenMegamenu = alreadyOpen;
            isMegamenuOpen = true;
            
            // Server already applied theme-white, just sync state
            if (headerBorder) {
                headerBorder.classList.add('border-hidden');
            }
            
            // Clear the cookie so it won't persist on reload
            clearMegamenuState();
            return;
        }
        
        const savedMegamenuId = getSavedMegamenuId();
        if (!savedMegamenuId) return;
        
        // Clear the cookie immediately so it won't persist on reload
        clearMegamenuState();
        
        isRestoringState = true;
        megamenuItems.forEach(item => {
            const megamenu = item.querySelector('.megamenu');
            if (!megamenu) return;
            
            const megamenuId = getMegamenuId(megamenu);
            if (megamenuId === savedMegamenuId) {
                openMegamenu(megamenu);
            }
        });
        isRestoringState = false;
    }

    // ============================================
    // SCROLL HANDLING
    // ============================================
    function updateHeaderOnScroll(forceUpdate = false) {
        const currentScrollY = window.scrollY;
        const scrolled = currentScrollY > scrollThreshold;
        const scrollDelta = Math.abs(currentScrollY - lastScrollY);
        const isScrollingUp = currentScrollY < lastScrollY;

        // Update last scroll direction when actively scrolling
        if (scrollDelta > 5) {
            lastScrollDirection = isScrollingUp ? 'up' : 'down';
        }

        // Close megamenu when user scrolls
        if (scrollDelta > 5 && isMegamenuOpen) {
            closeAllMegamenus();
        }
        
        lastScrollY = currentScrollY;

        if (scrolled !== isScrolled || forceUpdate) {
            isScrolled = scrolled;
            
            if (isScrolled) {
                // Apply scrolled state class
                applyScrolledState(true);
                
                // Apply theme based on scroll direction
                if (!isMobileMenuOpen && !isInitialLoad) {
                    // Use actual scroll direction if available, otherwise use last known direction
                    const directionToUse = scrollDelta > 5 ? isScrollingUp : (lastScrollDirection === 'up');
                    
                    if (directionToUse) {
                        applyTheme('theme-transparent');
                    } else {
                        applyTheme('theme-white');
                    }
                } else if (!isMobileMenuOpen && isInitialLoad) {
                    // During initial load, just apply white theme when scrolled
                    applyTheme('theme-white');
                }
            } else {
                // Remove scrolled state class
                applyScrolledState(false);
                
                // Revert to initial theme when at top (unless megamenu or mobile menu is open)
                const shouldRevert = forceUpdate 
                    ? !isMegamenuOpen && !isMobileMenuOpen
                    : !isMegamenuOpen && !isMobileMenuOpen;
                    
                if (shouldRevert) {
                    applyTheme(initialTheme);
                }
            }
        } else if (!forceUpdate && isMobileMenuOpen) {
            return;
        } else if (isScrolled && scrollDelta > 5 && !isMobileMenuOpen && !isInitialLoad) {
            // Handle scroll direction changes even when scroll state hasn't changed
            if (isScrollingUp) {
                applyTheme('theme-transparent');
            } else {
                applyTheme('theme-white');
            }
        }

        ticking = false;
    }

    function requestTick() {
        if (!ticking) {
            requestAnimationFrame(updateHeaderOnScroll);
            ticking = true;
        }
    }


    // ============================================
    // MOBILE MENU FUNCTIONS
    // ============================================
    function showPanel(panelId) {
        mobilePanels.forEach(panel => {
            panel.classList.remove('active', 'previous');
        });
        
        const targetPanel = document.querySelector(`[data-panel="${panelId}"]`);
        if (targetPanel) {
            targetPanel.classList.add('active');
            
            // Trigger staggered animation for submenu items
            const submenuItems = targetPanel.querySelectorAll('.mobile-submenu-item');
            if (submenuItems.length > 0) {
                submenuItems.forEach((item) => {
                    // Reset animation state
                    item.classList.remove('stagger-animate');
                    // Force reflow to restart animation
                    void item.offsetWidth;
                    // Add animation class
                    item.classList.add('stagger-animate');
                });
            }
            
            // Trigger staggered animation for grandchild items (simple list items)
            const grandchildItems = targetPanel.querySelectorAll('ul > li');
            const isGrandchildPanel = panelId.startsWith('grandchild-');
            if (isGrandchildPanel && grandchildItems.length > 0) {
                grandchildItems.forEach((item) => {
                    // Reset animation state
                    item.classList.remove('stagger-animate');
                    // Force reflow to restart animation
                    void item.offsetWidth;
                    // Add animation class
                    item.classList.add('stagger-animate');
                });
            }
        }
        
        // Apply 'previous' class to all panels in navigation history (except the current active one)
        for (let i = 0; i < panelHistory.length - 1; i++) {
            const historicalPanelId = panelHistory[i];
            const historicalPanel = document.querySelector(`[data-panel="${historicalPanelId}"]`);
            if (historicalPanel) {
                historicalPanel.classList.add('previous');
            }
        }
    }
    
    function navigateToPanel(panelId) {
        panelHistory.push(panelId);
        showPanel(panelId);
    }
    
    function navigateBack() {
        if (panelHistory.length > 1) {
            panelHistory.pop();
            const previousPanelId = panelHistory[panelHistory.length - 1];
            showPanel(previousPanelId);
        }
    }
    
    function resetPanels() {
        panelHistory = ['main'];
        mobilePanels.forEach(panel => {
            panel.classList.remove('active', 'previous');
        });
        const mainPanel = document.querySelector('[data-panel="main"]');
        if (mainPanel) {
            mainPanel.classList.add('active');
        }
    }
    
    function openMobileMenu() {
        if (!mobileMenu) return;
        
        isMobileMenuOpen = true;
        mobileMenu.classList.add('mobile-menu-open');
        mobileMenu.setAttribute('aria-hidden', 'false');
        mobileMenu.removeAttribute('inert');
        menuButton?.setAttribute('aria-expanded', 'true');
        menuButton?.classList.add('menu-open');
        document.body.classList.add('mobile-menu-open');
        
        resetPanels();
        
        // Remove scrolled state to expand header back to normal size
        applyScrolledState(false);
        
        // Switch to white theme when mobile menu opens
        applyTheme('theme-white');
        
        // Trigger staggered animation on menu items
        const menuItems = mobileMenu.querySelectorAll('.mobile-menu-item');
        menuItems.forEach((item, index) => {
            // Reset animation state
            item.classList.remove('stagger-animate');
            // Force reflow to restart animation
            void item.offsetWidth;
            // Add animation class
            item.classList.add('stagger-animate');
        });
    }
    
    function closeMobileMenu() {
        if (!mobileMenu) return;
        
        isMobileMenuOpen = false;
        mobileMenu.classList.remove('mobile-menu-open');
        mobileMenu.setAttribute('aria-hidden', 'true');
        mobileMenu.setAttribute('inert', '');
        menuButton?.setAttribute('aria-expanded', 'false');
        menuButton?.classList.remove('menu-open');
        document.body.classList.remove('mobile-menu-open');
        
        updateHeaderOnScroll(true);
        resetPanels();
        
        // Reset animation classes for next opening
        const menuItems = mobileMenu.querySelectorAll('.mobile-menu-item');
        menuItems.forEach(item => {
            item.classList.remove('stagger-animate');
        });
    }

    // ============================================
    // EVENT LISTENERS
    // ============================================
    if (menuButton) {
        menuButton.addEventListener('click', () => {
            const isOpen = menuButton.getAttribute('aria-expanded') === 'true';
            if (isOpen) {
                closeMobileMenu();
            } else {
                openMobileMenu();
            }
        });
    }
    
    if (mobileMenuClose) {
        mobileMenuClose.addEventListener('click', closeMobileMenu);
    }
    
    if (mobileMenuOverlay) {
        mobileMenuOverlay.addEventListener('click', closeMobileMenu);
    }
    
    mobileSubmenuToggles.forEach(toggle => {
        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            const targetPanelId = toggle.dataset.target;
            if (targetPanelId) {
                navigateToPanel(targetPanelId);
            }
        });
    });
    
    mobileGrandchildToggles.forEach(toggle => {
        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            const targetPanelId = toggle.dataset.target;
            if (targetPanelId) {
                navigateToPanel(targetPanelId);
            }
        });
    });
    
    mobileBackButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            navigateBack();
        });
    });
    
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && mobileMenu?.classList.contains('mobile-menu-open')) {
            closeMobileMenu();
        }
    });
    
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            if (window.innerWidth >= 1280 && mobileMenu?.classList.contains('mobile-menu-open')) {
                closeMobileMenu();
            }
        }, RESIZE_DEBOUNCE_DELAY);
    });
    
    // Megamenu click events
    megamenuItems.forEach(item => {
        const megamenu = item.querySelector('.megamenu');
        const link = item.querySelector('a');
        if (!megamenu || !link) return;
        
        link.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            const targetUrl = link.getAttribute('href');
            const isCurrentlyOpen = megamenu.classList.contains('megamenu-open');
            
            // Remove active state from all top-level nav items
            megamenuItems.forEach(otherItem => {
                const otherLink = otherItem.querySelector('a');
                const otherSpan = otherLink?.querySelector('span');
                if (otherLink && otherSpan) {
                    otherLink.setAttribute('data-nav-active', 'false');
                    otherLink.setAttribute('aria-current', 'false');
                    otherSpan.classList.remove('font-bold', 'text-gold', '!border-gold');
                }
            });
            
            // Add active state to clicked item
            const span = link.querySelector('span');
            if (span) {
                link.setAttribute('data-nav-active', 'true');
                link.setAttribute('aria-current', 'page');
                span.classList.add('font-bold', 'text-gold', '!border-gold');
            }
            
            if (!isCurrentlyOpen) {
                openMegamenu(megamenu);
            }
            
            if (targetUrl) {
                setTimeout(() => {
                    window.location.href = targetUrl;
                }, 300);
            }
        });
    });
    
    // Close megamenu when clicking outside
    document.addEventListener('click', (e) => {
        if (!isMegamenuOpen || !currentOpenMegamenu) return;
        
        const clickedInsideHeader = header.contains(e.target);
        const clickedInsideMegamenu = currentOpenMegamenu.contains(e.target);
        
        if (!clickedInsideHeader && !clickedInsideMegamenu) {
            closeAllMegamenus();
            applyTheme(initialTheme);
            
        }
    });
    
    header.addEventListener('click', (e) => {
        if (!isMegamenuOpen || !currentOpenMegamenu) return;
        
        const clickedOnMenuItem = Array.from(megamenuItems).some(item => item.contains(e.target));
        const clickedInsideMegamenu = currentOpenMegamenu.contains(e.target);
        
        if (!clickedOnMenuItem && !clickedInsideMegamenu) {
            closeAllMegamenus();
            applyTheme(initialTheme);   
            
        }
    });

    // ============================================
    // INITIALIZATION
    // ============================================
    restoreMegamenuState();
    updateHeaderOnScroll();
    window.addEventListener('scroll', requestTick, { passive: true });
    
    // Return cleanup function
    return function cleanup() {
        if (resizeTimer) clearTimeout(resizeTimer);
        if (megamenuCloseTimer) clearTimeout(megamenuCloseTimer);
        
        window.removeEventListener('scroll', requestTick);
        document.removeEventListener('keydown', closeMobileMenu);
        window.removeEventListener('resize', closeMobileMenu);
    };
}
